<template>
  <section class="section">
    <div class="container">
      <h1 class="title has-text-primary">
        <strong>Commentary</strong>
      </h1>
      <h2 class="subtitle has-text-grey-light is-4">{{ chapter.author }}</h2>
      <div class="content is-medium" v-html="markdown(chapter.essay_preview)">
      </div>
      <div class="level">
        <div class="level-item">
          <router-link
            :to="`/chapter/${chapter.id}/essay`"
            class="button is-primary is-medium">
            Continue Reading
          </router-link>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { markdown } from '@/utils.js'
export default {
  name: 'essayPreview',
  computed: {
    ...mapGetters(['chapter'])
  },
  methods: {
    markdown: markdown
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/EssayPreview.vue?03ae8a4c